import { render, staticRenderFns } from "./ServicerWrapper.vue?vue&type=template&id=4ae3324b&"
import script from "./ServicerWrapper.vue?vue&type=script&lang=js&"
export * from "./ServicerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ServicerWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports